import type React from 'react'

import { cn } from '@/lib/utils.ts'

export interface IndeterminateProgressBarProps {
  className?: string
}

export const IndeterminateProgressBar: React.FC<IndeterminateProgressBarProps> = ({ className }) => (
  <div className={cn('h-1 w-full overflow-hidden rounded-full bg-gray-200', className)}>
    <div className="animate-indeterminate h-full w-1/3 rounded-full bg-red-600" />
  </div>
)
